



































import Vue from 'vue'
import { PropValidator } from 'vue/types/options'
import { IDevice } from '@/types/model'
import RadioIcon from '@/components/RadioIcon.vue'
import AliveIndicator from '@/components/AliveIndicator.vue'
import HpdIcon from '@/components/HpdIcon.vue'
import DeviceTypeIcon from '@/components/DeviceTypeIcon.vue'
import PreviewScreen from '@/components/PreviewScreen.vue'
import easyapi from '@/easyapi'
import mixins from 'vue-typed-mixins'
import DeviceVendorIcon from '@/components/DeviceVendorIcon.vue'
import { getExtenderActiveUsage, ExtenderActiveStateSummary } from '@/utils'

export default Vue.extend({
  components: {
    PreviewScreen,
    RadioIcon,
    HpdIcon,
    DeviceTypeIcon,
    DeviceVendorIcon,
    AliveIndicator,
  },
  model: {
    prop: 'chosen',
    event: 'chose'
  },
  props: {
    /** Currently chosen in this radio group. Use v-model to access this. */
    chosen: {
      type: Object
    } as PropValidator<IDevice|null>,
    device: {
      type: Object
    } as PropValidator<IDevice>,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    thisDeviceIsChosen (): boolean { return this.device === this.chosen },
    usage (): ExtenderActiveStateSummary { return getExtenderActiveUsage(this.$state, this.device) },
    previewScreenMaxWidth (): number { return this.$state.common.windowSize.width - 260 },
    isDesktop (): boolean { return this.$state.common.windowSize.width > 770 },  // (800 x 600) - 30px
  },
  methods: {
    blinkLed () { easyapi.blinkLed(this, this.device) },
    openDeviceRenameDialog () { this.$router.push({ name: 'matrix_remap_rename', params: {mac: this.device.mac} }) },
    chooseThisDevice () {
      if (!this.disabled) {
        this.$emit('chose', this.device)
      }
    } // See the doc of v-model (v-model is a syntax sugar)
  }
})
